import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SelectModule } from 'src/app/common-components/entity-select/select/select.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { EntitySelectModule } from '../../common-components/entity-select/entity-select.module';
import { CallCostRegisterComponent } from './containers/call-cost-register.component';
import { CallCostRegisterEffects } from './state/call-cost-register.effects';
import { CallCostRegisterReducer, callCostsRegisterFeatureKey } from './state/call-cost-register.reducer';
import { CallCostRegisterViewComponent } from './views/call-cost-register-view.component';

@NgModule({
   declarations: [CallCostRegisterComponent, CallCostRegisterViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      SelectModule,
      ReactiveFormsModule,
      RouterModule,
      ScrollingModule,
      RegisterModule,
      EffectsModule.forFeature([CallCostRegisterEffects]),
      StoreModule.forFeature(callCostsRegisterFeatureKey, CallCostRegisterReducer),
      EntitySelectModule,
   ],
})
export class CallCostRegisterModule {}
